<template>
  <div
    style="
      position: relative;
      display: flex;
      flex-direction: column;
      border-right: 1px solid #e2e2e2;
    "
  >
    <div style="flex: 1; overflow-y: auto" class="menu">
      <el-menu
        default-active="2"
        class="el-menu-vertical-demo"
        :collapse="!state.showMenu"
        style="overflow: hidden; border-right: 0"
      >
        <el-image
          v-if="state.showMenu"
          :src="require('@/assets/images/logo.png')"
          style="width: 120px; margin: 10px"
          fit="contain"
        ></el-image>
        <el-image
          v-else
          :src="require('@/assets/images/logo1.png')"
          style="width: 40px; margin: 10px"
          fit="contain"
        ></el-image>

        <!-- 首页（独立菜单） -->
        <el-menu-item index="/home" @click="onMenuClick('HomeMain', '首页')">
          <el-icon :size="state.menuIconSize"><HomeFilled /></el-icon>
          <template #title>
            <span class="firstMenu">首页</span>
          </template>
        </el-menu-item>

        <!-- 动态渲染菜单组 -->
        <template v-for="group in visibleGroups" :key="group.index">
          <el-sub-menu :index="group.index">
            <template #title>
              <el-icon :size="state.menuIconSize">
                <component :is="group.icon" />
              </el-icon>
              <span class="firstMenu">{{ group.title }}</span>
            </template>

            <template v-for="(child, ci) in group.children" :key="child.path || child.index">
              <!-- 三级子菜单（如小程序管理） -->
              <el-sub-menu
                v-if="child.children"
                :index="child.index"
                class="secondSubMenu"
              >
                <template #title>
                  <span class="firstMenu">{{ child.title }}</span>
                </template>
                <el-menu-item
                  v-for="sub in child.children"
                  :key="sub.path"
                  :index="sub.path"
                  class="thirdMenu"
                  @click="onMenuClick(sub.path, sub.title)"
                >
                  {{ sub.title }}
                </el-menu-item>
              </el-sub-menu>
              <!-- 普通菜单项 -->
              <el-menu-item
                v-else
                :index="String(group.index) + '-' + (ci + 1)"
                class="secondMenu"
                @click="onMenuClick(child.path, child.title)"
              >
                {{ child.title }}
              </el-menu-item>
            </template>
          </el-sub-menu>
        </template>
      </el-menu>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 10px;
        margin-top: 2px;
        padding-top: 10px;
        border-top: 1px solid #e2e2e2;
        cursor: pointer;
        border-right: 1px solid #e2e2e2;
      "
    >
      <el-icon
        size="20"
        color="#2f2f2f"
        @click="state.showMenu = !state.showMenu"
        ><Fold v-if="state.showMenu" /> <Expand v-else
      /></el-icon>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, computed } from "vue";
import store from "@/store";
import { menuTree } from "@/config/menuConfig";

export default {
  setup() {
    const state = reactive({
      showMenu: true,
      menuIconSize: 18,
    });
    onMounted(() => {});

    const user = computed(() => store.state.loginUser);

    // 判断用户是否拥有指定权限（超管拥有所有权限）
    const hasPermission = (perm) => {
      if (!perm) return true;
      if (user.value?.IsAdmin) return true;
      return user.value?.Qxs?.includes(perm) ?? false;
    };

    // 过滤后的菜单组（仅包含用户可见的菜单）
    const visibleGroups = computed(() => {
      return menuTree
        .map((group) => {
          const filteredChildren = (group.children || []).filter((child) => {
            if (child.children) {
              // 三级子菜单组（如小程序管理）
              const subVisible = (child.children || []).filter((sub) =>
                hasPermission(sub.permission ? "M_" + sub.permission : null)
              );
              if (subVisible.length === 0) return false;
              return hasPermission(
                child.permissions?.some((p) => hasPermission(p))
                  ? child.permissions[0] // 只需有一个权限即可显示父级
                  : null
              );
            }
            return hasPermission(
              child.permission ? "M_" + child.permission : null
            );
          });
          return { ...group, children: filteredChildren };
        })
        .filter((group) => {
          // 父菜单可见性：超管直接可见，否则检查 permissions 数组
          if (user.value?.IsAdmin) return true;
          return group.permissions?.some((p) => hasPermission(p)) ?? false;
        });
    });

    const onMenuClick = (path, title) => {
      store.commit("openMenu", { path, title, refresh: true });
    };

    return { state, visibleGroups, onMenuClick };
  },
};
</script>
<style scoped>
.menu::-webkit-scrollbar {
  width: 0 !important;
}

.firstMenu {
  font-size: 12px;
}

.menu .secondMenu {
  font-size: 12px;
  /* color: rgb(26, 167, 38); */
  display: flex;
  align-items: center;
  padding-right: 0 !important;
  padding-left: 50px !important;
}

.el-popper .secondMenu {
  font-size: 12px;
  /* color: rgb(26, 167, 38); */
  display: flex;
  align-items: center;
  padding-right: 0 !important;
}

.menu .thirdMenu {
  font-size: 12px;
  display: flex;
  align-items: center;
  padding-right: 0 !important;
  padding-left: 70px !important;
}

.el-popper .thirdMenu {
  font-size: 12px;
  display: flex;
  align-items: center;
  padding-right: 0 !important;
}

.menu .secondSubMenu :deep(.el-sub-menu__title) {
  padding-left: 50px !important;
}
</style>
